import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { patchState, signalState } from '@ngrx/signals';
import { EnvironmentUrlUtilsService, SphereUrlEnvironmentInfo, SubEnvironmentName } from '../../../utils';
import { MatTooltip } from '@angular/material/tooltip';
import { UpperCasePipe } from '@angular/common';
import { ColorStatusIndicatorComponent } from '../../color-status-indicator/color-status-indicator.component';
import { AppConfigService } from '../../../services/app-config.service';

export type BottomToolbarState = {
    environmentInfo: SphereUrlEnvironmentInfo | null;
    platformVersion: string;
    appVersion: string;
};

@Component({
    selector: 'sphere-shell-environment-indicator',
    templateUrl: './environment-indicator.component.html',
    styleUrls: ['./environment-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTooltip, ColorStatusIndicatorComponent, UpperCasePipe]
})
export class EnvironmentIndicatorComponent {
    public readonly state = signalState<BottomToolbarState>({
        environmentInfo: null,
        appVersion: '',
        platformVersion: ''
    });

    public readonly environmentColor = computed(() => {
        if (this.state.environmentInfo()?.subEnvironment) {
            switch (this.state.environmentInfo()?.subEnvironment) {
                case SubEnvironmentName.alpha:
                    return '#006cb8';
                case SubEnvironmentName.qa:
                    return '#b86e00';
                case SubEnvironmentName.staging:
                case SubEnvironmentName.dataqa:
                    return '#910c36';
                case SubEnvironmentName.ob:
                    return '#0c4771';
                case SubEnvironmentName.uat:
                    return '#aa8a13';
                case SubEnvironmentName.prod:
                    return '#2a5e16';
            }
        }
        return '#888888';
    });

    constructor() {
        const environmentHelper = inject(EnvironmentUrlUtilsService);
        const appConfig = inject(AppConfigService);

        patchState(this.state, {
            environmentInfo: environmentHelper.currentEnvironmentInfo,
            platformVersion: appConfig.platformVersion,
            appVersion: appConfig.appVersion
        });
    }
}
